<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
//
// import 'element-ui/lib/theme-chalk/index.css'
// import elementLocale from 'element-ui/lib/locale/lang/ru-RU'
//
// Vue.use(ElementUI, { locale: elementLocale })

export default {
  name: 'App'
}
</script>

<style lang="scss">
@import '@/assets/styles/app.scss';

body {
  margin: 0;
  padding: 0;

  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app {
  margin: 0;
}
</style>
